export const getValidMobileNumber = (mobile: string) => {
  let mobileNumber = mobile;
  if (mobileNumber.length > 10) {
    if (mobileNumber.length === 12 && mobileNumber.indexOf("91") == 0) {
      mobileNumber = mobileNumber.slice(2);
    } else if (
      mobileNumber.length === 13 &&
      (mobileNumber.indexOf("+91") === 0 || mobileNumber.indexOf("91 ") === 0)
    ) {
      mobileNumber = mobileNumber.slice(3);
    } else if (
      mobileNumber.length === 14 &&
      mobileNumber.indexOf("+91 ") === 0
    ) {
      mobileNumber = mobileNumber.slice(4);
    }
  }
  return mobileNumber;
};

// Convert phone number to E.164 format
export const formatPhoneToE164 = (phone: string): string => {
  if (!phone) return "";
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, "");
  
  // If it's already in E.164 format (starts with +), return as is
  if (phone.startsWith("+")) {
    return phone;
  }
  
  // If it's a 10-digit Indian number, add +91 prefix
  if (cleaned.length === 10) {
    return `+91${cleaned}`;
  }
  
  // If it's already 12 digits and starts with 91, add + prefix
  if (cleaned.length === 12 && cleaned.startsWith("91")) {
    return `+${cleaned}`;
  }
  
  // If it's already 13 digits and starts with 91, add + prefix
  if (cleaned.length === 13 && cleaned.startsWith("91")) {
    return `+${cleaned}`;
  }
  
  // For other cases, assume it's an Indian number and add +91 prefix
  // This handles cases where the number might be less than 10 digits
  return `+91${cleaned}`;
};

// Format date
export function convertDate(dateString: string) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}
